module.exports = __webpack_public_path__ + "img/icon-credit-card.84ecad84.svg";